import React from 'react';

import { Container, Heading } from './ErrorBoundary.styles';

export const ErrorBoundaryView = ({ errorMessage }) => (
    <Container>
        <Heading>{errorMessage}</Heading>
    </Container>
);

ErrorBoundaryView.displayName = 'ErrorBoundaryView';
